(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('quoting', {
            parent: 'entity',
            url: '/quoting',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.quoting.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/quoting/quotings.html',
                    controller: 'QuotingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('quoting');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('quoting-detail', {
            parent: 'quoting',
            url: '/quoting/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.quoting.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/quoting/quoting-detail.html',
                    controller: 'QuotingDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('quoting');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Quoting', function($stateParams, Quoting) {
                    return Quoting.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'quoting',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('quoting-detail.edit', {
            parent: 'quoting-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quoting/quoting-dialog.html',
                    controller: 'QuotingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Quoting', function(Quoting) {
                            return Quoting.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('quoting.new', {
            parent: 'quoting',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quoting/quoting-dialog.html',
                    controller: 'QuotingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                compound: null,
                                parCouponFreq: null,
                                deltaPeriods: null,
                                zeroRate: null,
                                forwardRate: null,
                                parRate: null,
                                dirtyPrice: null,
                                cleanPrice: null,
                                ytm: null,
                                residualMaturity: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('quoting', null, { reload: 'quoting' });
                }, function() {
                    $state.go('quoting');
                });
            }]
        })
        .state('quoting.edit', {
            parent: 'quoting',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quoting/quoting-dialog.html',
                    controller: 'QuotingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Quoting', function(Quoting) {
                            return Quoting.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('quoting', null, { reload: 'quoting' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('quoting.delete', {
            parent: 'quoting',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quoting/quoting-delete-dialog.html',
                    controller: 'QuotingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Quoting', function(Quoting) {
                            return Quoting.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('quoting', null, { reload: 'quoting' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
